import type { Metadata } from './components/DocumentHead';

export const siteName = 'FineSoft Components';
export const siteUrl = 'https://components.finesoft.org';
export const repositoryUrl = 'https://github.com/GaKireiTsuki/finesoft-components';
export const upstreamUrl = 'https://base-ui.com';
export const siteDescription = 'FineSoft Components is an independent Stencil Web Components library, with Base UI React references and side-by-side examples.';

export const siteMetadata: Metadata = {
  title: { default: siteName, template: `%s · ${siteName}` },
  description: siteDescription,
  metadataBase: siteUrl,
  twitter: { card: 'summary' },
  openGraph: { type: 'website', siteName, locale: 'en_US' },
  icons: { icon: [{ rel: 'icon', type: 'image/svg+xml', url: '/static/finesoft.svg' }] },
};
